import { FormInput } from '@/domain/mitarbeiter/features/anlageassistent/types/types';

export const anlageassistentFormDefaultValues = {
  person: {
    persoenliches: {
      anrede: null,
      vorname: '',
      nachname: '',
      rufname: null,
      personalnummer: null,
      e2nId: null,
    },
    kontakt: {
      email: null,
      mobilnummer: null,
      strict: false,
    },
    arbeitsbereiche: {
      primaererArbeitsbereich: '',
      sekundaereArbeitsbereiche: [],
      erfahrungslevel: null,
    },
  },
  anstellungsverhaeltnis: {
    anstellung: {
      anstellungstyp: '',
      eintrittsdatum: null,
      befristet: false,
      befristung: null,
    },
    fristen: [],
  },
  bezahlung: {
    bezahlungsart: {
      art: null,
      stundenlohn: null,
      monatsgehalt: null,
      tarifGruppe: null,
    },
    arbeitszeitkonto: {
      art: null,
      gehaltsempfaenger: {
        sollstunden: null,
        stundenpensum: null,
        berechnungsartMonat: null,
        monatsstunden: null,
        unbezahlteUeberstundenMonat: null,
        wochenstunden: null,
        unbezahlteUeberstundenWoche: null,
        arbeitstage: [],
        tagessoll: null,
      },
      stundenloehner: {
        auszahlungsgrenze: null,
        richtwert: null,
      },
    },
    zuschlaege: {
      zuschlaege: null,
      zuschlagsgruppe: null,
      pauschaleZuschlaege: null,
      uebertariflicheZahlung: null,
      strict: false,
    },
  },
  abwesenheiten: {
    allgemein: {
      anzahlUrlaubstage: '',
      anzahlArbeitstage: null,
      stundenBewertung: null,
      stunden: null,
      dynamisch: null,
      dynamisch_wochenschnitt_start: null,
      dynamisch_wochenschnitt_limitieren: null,
      dynamisch_drei_monatsschnitt_berechnungsgrundlage: null,
    },
    guttage: {
      guttageBewerten: false,
    },
    feiertagseinstellungen: {
      zuschlagsregelungGreift: false,
      stundenGutschreibung: false,
      taeglicheArbeitszeitAuffuellen: false,
    },
  },
  speicheroptionen: {
    personalzugang: false,
    personalfragebogen: false,
  },
} satisfies FormInput as FormInput;
